import * as THREE from 'three';

// import { TrackballControls } from "three/examples/jsm/controls/TrackballControls.js";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { OBJLoader2 } from 'three/examples/jsm/loaders/OBJLoader2.js';
import { MtlObjBridge } from 'three/examples/jsm/loaders/obj2/bridge/MtlObjBridge.js';

// Development Utility flags.
const clickToStart = true;
const showHelperGrid = false;

const canvasElementID = 'threeDimensionalObjectViewer';

export default function () {
  const canvasDOMElem = document.getElementById(canvasElementID);
  if (!canvasDOMElem) {
    // Abort if the DOM container element isn't present on the page.
    return;
  }
  const my3DFileLocation = canvasDOMElem.dataset.threedfile || false;
  const myMTLfilelocation = canvasDOMElem.dataset.mtlfile || false;
  const cameraPositionVector = [
    Number(canvasDOMElem.dataset.cameraposx),
    Number(canvasDOMElem.dataset.cameraposy),
    Number(canvasDOMElem.dataset.cameraposz),
  ];
  const cameraTargetVector = [
    Number(canvasDOMElem.dataset.camertargetx),
    Number(canvasDOMElem.dataset.camertargety),
    Number(canvasDOMElem.dataset.camertargetz),
  ];
  const objOriginOffset = [
    Number(canvasDOMElem.dataset.objoffsetx),
    Number(canvasDOMElem.dataset.objoffsety),
    Number(canvasDOMElem.dataset.objoffsetz),
  ];
  const OBJLoader2Example = function (elementToBindTo) {
    this.renderer = null;
    this.canvas = elementToBindTo;
    this.aspectRatio = 1;
    this.recalcAspectRatio();

    this.scene = null;

    // Settings for ID 135
    // this.cameraDefaults = {
    //   posCamera: new THREE.Vector3(0.0, 0.3, 2),
    //   posCameraTarget: new THREE.Vector3(0, 0, 0),
    //   near: 1,
    //   far: 10000,
    //   fov: 45,
    // };

    this.cameraDefaults = {
      posCamera: new THREE.Vector3(...cameraPositionVector),
      posCameraTarget: new THREE.Vector3(...cameraTargetVector),
      near: 1,
      far: 10000,
      fov: 45,
    };
    this.camera = null;
    this.cameraTarget = this.cameraDefaults.posCameraTarget;

    this.controls = null;
  };

  OBJLoader2Example.prototype = {
    constructor: OBJLoader2Example,

    initGL: function () {
      this.renderer = new THREE.WebGLRenderer({
        canvas: this.canvas,
        antialias: true,
        autoClear: true,
      });
      this.renderer.setClearColor(0x050505);

      this.scene = new THREE.Scene();

      this.camera = new THREE.PerspectiveCamera(
        this.cameraDefaults.fov,
        this.aspectRatio,
        this.cameraDefaults.near,
        this.cameraDefaults.far
      );
      this.resetCamera();

      // this.controls = new TrackballControls(this.camera, this.renderer.domElement);
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);

      this.camera.position.set(...cameraPositionVector);
      // this.controls.target.set(...objOriginOffset);
      this.controls.target.set(...objOriginOffset);
      this.controls.autoRotate = true;
      this.controls.enableZoom = false;
      this.controls.update();

      if (true) {
        // Ambient Light:
        const light = new THREE.AmbientLight(0x909090); // soft white light scene.add( light );
        this.scene.add(light);
      }

      if (true) {
        // // Light 1
        const directionalLight1 = new THREE.DirectionalLight(0x707070);
        directionalLight1.position.set(-200, -100, 200);
        this.scene.add(directionalLight1);
      }

      if (true) {
        // // Light 2
        const directionalLight2 = new THREE.DirectionalLight(0x808080);
        directionalLight2.position.set(100, 50, -100);
        this.scene.add(directionalLight2);
      }

      if (false) {
        // Directional Light:
        // White directional light at half intensity shining from the top.
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
        this.scene.add(directionalLight);
      }

      if (false) {
        // Spot Light:
        // white spotlight shining from the side, casting a shadow
        const spotLight = new THREE.SpotLight(0xffffff);
        spotLight.position.set(100, 1000, 100);
        spotLight.castShadow = true;
        spotLight.shadow.mapSize.width = 1024;
        spotLight.shadow.mapSize.height = 1024;
        spotLight.shadow.camera.near = 500;
        spotLight.shadow.camera.far = 4000;
        spotLight.shadow.camera.fov = 30;
        this.scene.add(spotLight);
      }

      if (showHelperGrid) {
        const helper = new THREE.GridHelper(1200, 60, 0x449999, 0x404040);
        this.scene.add(helper);
      }
    },

    initContent: function () {
      this._reportProgress({ detail: { text: 'Loading…' } });

      const scope = this;

      if (my3DFileLocation.split('.').pop() === 'glb') {
        var loader = new GLTFLoader();
        loader.load(my3DFileLocation, function (gltf) {
          gltf.scene.traverse(function (child) {
            if (child.isMesh) {
              // TOFIX RoughnessMipmapper seems to be broken with WebGL 2.0
              // roughnessMipmapper.generateMipmaps( child.material );
            }
          });

          scope.scene.add(gltf.scene);

          // roughnessMipmapper.dispose();
          scope._reportProgress({ detail: { text: '' } });

          render();
        });
      } else if (my3DFileLocation.split('.').pop() === 'obj') {
        // No GLB file, try for OBJ/MTL
        const objLoader2 = new OBJLoader2();
        const callbackOnLoad = function (object3d) {
          scope.scene.add(object3d);
          scope._reportProgress({ detail: { text: '' } });
        };
        // If there is an accompanying .MTL file load that too (using the same filename with different extensions).
        if (myMTLfilelocation) {
          // OBJ and MTL files are available.
          const onLoadMtl = function (mtlParseResult) {
            objLoader2.setLogging(true, true);
            objLoader2.addMaterials(
              MtlObjBridge.addMaterialsFromMtlLoader(mtlParseResult),
              true
            );
            objLoader2.load(my3DFileLocation, callbackOnLoad, null, null, null);
          };
          const mtlLoader = new MTLLoader();
          mtlLoader.load(myMTLfilelocation, onLoadMtl);
        } else {
          // Only the OBJ file is available.
          objLoader2.load(my3DFileLocation, callbackOnLoad, null, null, null);
        }
      }
    },

    _reportProgress: function (event) {
      let output = '';
      if (
        event.detail !== null &&
        event.detail !== undefined &&
        event.detail.text
      ) {
        output = event.detail.text;
      }
      // console.log('Progress: ' + output);
      document.getElementById('feedback').innerHTML = output;
    },

    resizeDisplayGL: function () {
      // this.controls.handleResize();

      this.recalcAspectRatio();
      this.renderer.setSize(
        this.canvas.offsetWidth,
        this.canvas.offsetHeight,
        false
      );

      this.updateCamera();
    },

    recalcAspectRatio: function () {
      this.aspectRatio =
        this.canvas.offsetHeight === 0
          ? 1
          : this.canvas.offsetWidth / this.canvas.offsetHeight;
    },

    resetCamera: function () {
      this.camera.position.copy(this.cameraDefaults.posCamera);
      this.cameraTarget.copy(this.cameraDefaults.posCameraTarget);

      this.updateCamera();
    },

    updateCamera: function () {
      this.camera.aspect = this.aspectRatio;
      this.camera.lookAt(this.cameraTarget);
      this.camera.updateProjectionMatrix();
    },

    render: function () {
      if (!this.renderer.autoClear) this.renderer.clear();
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
    },
  };

  const app = new OBJLoader2Example(document.getElementById(canvasElementID));

  const resizeWindow = function () {
    app.resizeDisplayGL();
  };

  const render = function () {
    requestAnimationFrame(render);
    app.render();
  };

  window.addEventListener('resize', resizeWindow, false);
  // console.log('logging', document.getElementById(canvasElementID));
  if (clickToStart) {
    document.getElementById(canvasElementID).addEventListener(
      'click',
      function () {
        // console.log('Starting initialisation phase...');
        app.initGL();
        app.resizeDisplayGL();
        app.initContent();
        render();
      },
      { once: true }
    );
  } else {
    app.initGL();
    app.resizeDisplayGL();
    app.initContent();
    render();
  }
}
